import React, { useState } from 'react';

function FilterModal({ onFilter }) {
  const [status, setStatus] = useState('');
  const [bookingCode, setBookingCode] = useState('');
  const [fullname, setFullname] = useState('');
  const [bookedForDate, setBookedForDate] = useState('');

  const filterData = () => {
    onFilter(status, bookingCode, fullname, bookedForDate);
    document.getElementById('closeModal').click();
  };

  return (
    <div className="modal" tabIndex="-1" id="exampleModal">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Filter Data</h5>
            <button
              id="closeModal"
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <div className="form-group">
              <label className="fw-600 mb-10">Kode Booking</label>
              <input
                value={bookingCode}
                onChange={(e) => {
                  setBookingCode(e.target.value);
                }}
                type="text"
                className="form-control"
              />
            </div>
            <div className="form-group">
              <label className="fw-600 mb-10">Nama Pemesan</label>
              <input
                value={fullname}
                onChange={(e) => {
                  setFullname(e.target.value);
                }}
                type="text"
                className="form-control"
              />
            </div>
            <div className="form-group">
              <label className="fw-600 mb-10">Status</label>
              <select
                className="form-control"
                value={status}
                onChange={(e) => {
                  setStatus(e.target.value);
                }}>
                <option value="">Semua Status</option>
                <option value="NEW">Baru</option>
                <option value="RESCHEDULE">Reschedule</option>
                <option value="APPROVED">Payment</option>
                <option value="PAID">Dijadwalkan</option>
                <option value="EXECUTION">Diproses</option>
                <option value="DONE">Selesai</option>
                <option value="REJECTED">Ditolak</option>
                <option value="REFUND">Refund</option>
              </select>
            </div>
            <div className="form-group">
              <label className="fw-600 mb-10">Jadwal Pelaksanaan</label>
              <input
                value={bookedForDate}
                onChange={(e) => {
                  setBookedForDate(e.target.value);
                }}
                type="date"
                className="form-control"
              />
            </div>
          </div>
          <div className="modal-footer">
            <button
              onClick={filterData}
              type="button"
              className="btn btn-primary bg-blue-1 rounded-1">
              Filter Data
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FilterModal;
